import request from '@/utils/request'

// 走勢 api

export const getTrand = function(cpCode, query) {
  return request({
    url: `/v1/cp168/apis/ruleDetails/${cpCode}`,
    method: 'get',
    params: query
  })
}

export const getTmHotColdRank = function(query) {
  return request({
    url: '/v1/cp168/apis/newspaper/tmHotColdRank',
    method: 'get',
    params: query
  })
}
